<template>

</template>

<script>
export default {
    name: "role_notification",

    props : {
        role_item : {
            type : Object
        }
    },

    created() {
        this.loadRestaurants();
    },

    methods : {
        loadRestaurants()
        {

        }
    }
}
</script>



<style scoped>

</style>
